import { useCallback, useEffect, useState } from "react";
import { authApi } from "../api/authApi";
import { storage } from "../utils";

export function useAuth() {
  const [token, setToken] = useState(() => storage.getToken());
  const [isAuthenticated, setIsAuthenticated] = useState(() =>
    storage.hasToken()
  );
  const [isCheckingAuth, setIsCheckingAuth] = useState(() =>
    storage.hasToken()
  );

  useEffect(() => {
    if (!token) {
      setIsCheckingAuth(false);
      return;
    }

    let isMounted = true;

    authApi
      .checkAuth()
      .then((res) => {
        if (!isMounted) return;
        if (res.data?.isAuthenticated) {
          setIsAuthenticated(true);
        } else {
          storage.removeToken();
          setIsAuthenticated(false);
          setToken(null);
        }
      })
      .catch(() => {
        if (!isMounted) return;
        storage.removeToken();
        setIsAuthenticated(false);
        setToken(null);
      })
      .finally(() => {
        if (isMounted) setIsCheckingAuth(false);
      });

    return () => {
      isMounted = false;
    };
  }, [token]);

  const login = useCallback(async (username, password) => {
    const res = await authApi.login({ username, password });
    const newToken = res.data?.token;
    if (!newToken) throw new Error("Missing token");
    storage.setToken(newToken);
    setToken(newToken);
    setIsAuthenticated(true);
  }, []);

  const logout = useCallback(async () => {
    storage.removeToken();
    setToken(null);
    setIsAuthenticated(false);
    try {
      await authApi.logout();
    } catch {
      // non critical
    }
  }, []);

  return { isAuthenticated, isCheckingAuth, login, logout };
}
